import React from 'react'
import '../css/Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <div className='container'>
                <ul>
                    <li>
                        <a className='nav-item' href='/'>Home</a>
                    </li>
                    <li>
                        <a className='nav-item' href='/'>About</a>
                    </li>
                    <li>
                        <a className='nav-item' href='/'>Demo</a>
                    </li>
                </ul>
                <div className='contacts'>
                    Contact
                    <p>(949)-414-6806</p>
                    <p>support@leeaerials.com</p>
                </div>
                <div className='bottom'>
                    <span className='line' />
                    <p>2024 Lee Aerials All rights reserved</p>
                </div>
            </div>
        </div>
    )
}


export default Footer;